/**
 * @file Input group component.
 */

import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import Label from './Label';
import Input from './Input';

const propTypes = {
  id: PropTypes.string.isRequired,
  type: PropTypes.oneOf([
    'text',
    'password',
    'email',
    'url',
    'search',
    'number',
    'hidden',
  ]),
  label: PropTypes.node,
  labelNote: PropTypes.string,
  labelTip: PropTypes.string,
  labelSrOnly: PropTypes.bool,
  labelType: PropTypes.oneOf(['standard', 'expanded']),
  addon: PropTypes.oneOfType([PropTypes.node, PropTypes.string]),
  className: PropTypes.string,
  inputClassName: PropTypes.string,
  placeholder: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  inputRef: PropTypes.oneOfType([PropTypes.object, PropTypes.func]),
  wrapperRef: PropTypes.oneOfType([PropTypes.object, PropTypes.func]),
  note: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  disabled: PropTypes.bool,
  wrapperClassName: PropTypes.string,
  size: PropTypes.oneOf(['sm']),
  required: PropTypes.bool,
  labelProps: PropTypes.object,
  error: PropTypes.bool,
};

const InputGroup = ({
  id,
  type = 'text',
  className,
  label,
  labelNote,
  labelTip,
  labelSrOnly,
  labelType,
  addon,
  inputClassName,
  placeholder,
  inputRef,
  wrapperRef,
  note,
  disabled,
  wrapperClassName,
  size,
  required,
  labelProps,
  error,
  ...props
}) => {
  const classes = classNames({
    'input-group': true,
    [className]: !!className,
  });

  const wrapperClasses = classNames({
    'input-group-wrap': true,
    [`input-group-${size}`]: !!size,
    disabled,
    [wrapperClassName]: !!wrapperClassName,
  });

  return (
    <div className={wrapperClasses} ref={wrapperRef}>
      {label && (
        <Label
          id={id}
          label={label}
          labelNote={labelNote}
          labelTip={labelTip}
          labelSrOnly={labelSrOnly}
          labelType={labelType}
          required={required}
          error={error}
          {...labelProps}
        />
      )}

      <div className={classes}>
        {addon && <span className="input-group-addon">{addon}</span>}
        <Input
          id={id}
          type={type}
          className={inputClassName}
          placeholder={placeholder}
          inputRef={inputRef}
          disabled={disabled}
          size={size}
          required={required}
          error={error}
          {...props}
        />
      </div>
      {note}
    </div>
  );
};

InputGroup.propTypes = propTypes;

export default InputGroup;
